import { IBaseComponentProps, NSBoxTextArea } from "namirasoft-site-react";
import { Component, createRef } from "react";
import Styles from "./RetrieveValue.module.css"

export interface RetrieveValueProps extends IBaseComponentProps
{ }

export default class RetrieveValue extends Component<RetrieveValueProps>
{
    private NSBoxTextArea_Value = createRef<NSBoxTextArea>();

    constructor(props: RetrieveValueProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
    }

    getValue()
    {
        return this.NSBoxTextArea_Value.current?.getValue() ?? "";
    }

    setValue(value: string)
    {
        this.NSBoxTextArea_Value.current?.setValue(value);
    }

    override render()
    {
        return <div className={Styles.retrieve_value_container}>
            <NSBoxTextArea
                ref={this.NSBoxTextArea_Value}
                required
                title="Value"
                rows={10}
                style={{ width: "100%", maxWidth: "unset" }}
                info={{ link: "https://namirasoft.com/secret/console-guide/secret/#field-value" }}
            />
        </div>;
    }
}